export default {
  UPDATE_SELECTED_KEYWORDS (state, ids) {
    state.selectedIds = ids
  },
  ADD_SELECTED_KEYWORDS (state, ids) {
    ids = ids.filter((id) => { if (!state.selectedIds.includes(id)) return id })
    state.selectedIds = state.selectedIds.concat(ids)
  },
  REMOVE_SELECTED_KEYWORDS (state, ids) {
    state.selectedIds = state.selectedIds.filter((id) => { return !ids.includes(id) })
  },
  UPDATE_SELECTED_FOR_CHART (state, ids) {
    state.selectedForChartIds = ids
  },
  ADD_SELECTED_FOR_CHART (state, ids) {
    ids = ids.filter((id) => { if (!state.selectedForChartIds.includes(id)) return id })
    state.selectedForChartIds = state.selectedForChartIds.concat(ids)
  },
  REMOVE_SELECTED_FOR_CHART (state, ids) {
    state.selectedForChartIds = state.selectedForChartIds.filter((id) => { return !ids.includes(id) })
  },
  SET_ALL_KEYWORDS_FOR_CHART (state, ids) {
    state.allKeywordsForChart = ids
  }
}



// WEBPACK FOOTER //
// ./src/store/keyword/mutations.js